import { Card, CardHeader, CardTitle, CardDescription } from "../../components/ui/Card";

// Shown when Atlas refuses a Claude connect request it cannot send back to
// Claude. No technical error text: the fix is always to start again from Claude.
export default function OauthError() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-muted/40 px-4">
      <div className="flex items-center gap-2.5 mb-8">
        <div className="w-[30px] h-[30px] rounded-md bg-foreground text-background flex items-center justify-center text-sm font-semibold">A</div>
        <span className="text-sm font-semibold text-foreground" style={{ letterSpacing: "-0.01em" }}>ATLAS AI</span>
      </div>

      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle className="text-xl">This Claude connection didn't work</CardTitle>
          <CardDescription>Go back to Claude and click Connect again. If it still doesn't work, ask your Atlas admin.</CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}
